import { useTranslation } from 'react-i18next';

interface RatingStarsProps {
  value: number;
  count?: number;
  isRxProduct?: boolean;
}

export function ProductRatingStars({
                                     value,
                                     count = 0,
                                     isRxProduct = false,
                                   }: RatingStarsProps): JSX.Element {
  const totalStars = 5;
  const ratingPercentage = (value / totalStars) * 100;
  const stars = new Array(totalStars).fill(null);
  const { t } = useTranslation();

  return (
    <div
      className="product-card__rating"
      aria-label={t( "search.hits.productCard.ratingLabel",  { value, totalStars, count } ) as string }      role="img"
    >
      {!isRxProduct && (
        <>
          <div
            className="product-card__rating-foreground"
            style={{ width: `${ratingPercentage}%` }}
            aria-hidden="true"
          >
            {stars.map((_, index) => (
              <svg
                key={index}
                className="rating-star rating-star--active"
                width="12"
                height="12"
              >
                <use href="#icon_rating-star-solid" />
              </svg>
            ))}
          </div>
          <div className="product-card__rating-background" aria-hidden="true">
            {stars.map((_, index) => (
              <svg
                key={index}
                className="rating-star"
                width="12"
                height="12"
              >
                <use href="#icon_rating-star-outline" />
              </svg>
            ))}
          </div>
          <span className="product-card__review-count" aria-hidden="true">
            ({count})
          </span>
        </>
      )}
    </div>
  );
}